"use strict";

exports.__esModule = true;
var _DeviceTagSelector = require("./DeviceTagSelector");
Object.keys(_DeviceTagSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceTagSelector[key]) return;
  exports[key] = _DeviceTagSelector[key];
});